import { boolean, InferType, object } from "yup";

export const roadmapVisibilityConditionsSchema = object({
  isMDR: boolean().optional(),
  isIVDR: boolean().optional(),
  isFDA: boolean().optional(),
  isUK: boolean().optional(),
  isCanada: boolean().optional(),
  hasHardware: boolean().optional(),
  hasSoftware: boolean().optional(),
  hasElectrical: boolean().optional(),
  hasSterile: boolean().optional(),
  hasFirmware: boolean().optional(),
  hasMechanical: boolean().optional(),
  hasImplantable: boolean().optional(),
  isSoftwareOnly: boolean().optional(),
  isClass1: boolean().optional(),
  isClass2a: boolean().optional(),
  isClass2b: boolean().optional(),
  isClass3: boolean().optional(),
});

export type RoadmapVisibilityConditions = InferType<
  typeof roadmapVisibilityConditionsSchema
>;
